import { useEffect } from "react";

import { ONE } from "../../components/Header/constants";
import { ActivationComponentAssets } from "../../helpers/ActivationAssets";
import { useLocalStorage } from "../helpers/useLocalStorage";

const LAST_SELECTED_ACTIVATION_KEY = "lastSelectedActivationKey";

export const useLastSelectedSet = (activationId?: string) => {
    const { getLocalStorage, removeLocalStorage, setLocalStorage } = useLocalStorage();

    const getLastSelectedActivation = () => getLocalStorage(LAST_SELECTED_ACTIVATION_KEY);

    const removeLastSelectedActivation = () => removeLocalStorage(LAST_SELECTED_ACTIVATION_KEY);

    useEffect(() => {
        const isMultiSet = ActivationComponentAssets.activationSetsLimitation > ONE;
        const currentActivationId = getLastSelectedActivation();

        if (isMultiSet && activationId && activationId !== currentActivationId) {
            setLocalStorage(LAST_SELECTED_ACTIVATION_KEY, activationId);
            return;
        }

        if (!isMultiSet && currentActivationId) {
            removeLocalStorage(LAST_SELECTED_ACTIVATION_KEY);
        }
    }, [activationId]);

    return {
        removeLastSelectedActivation,
        getLastSelectedActivation,
    };
};
